const orientations = {
  direita: {x:0, y:1.576, z:0},
  esquerda: {x:0, y:-1.576, z:0},
  frente: {x:0, y:0, z:0},
  costas: {x:0, y:3.135, z:0}
}

export default orientations